import React from 'react';
import {
  LocaleProvider,
  Menu,
  Icon,
  Button,
  Popover,
  Avatar,
  Row,
  Col,
  Divider,
  Typography,
  Card,
  notification,
  message,
} from 'antd';
import viVn from 'antd/lib/locale-provider/vi_VN';
import enEn from 'antd/lib/locale-provider/en_US';
import { DashboardLayout, DashboardPropsType, FooterO2OComponent, AvartarMenuPopover } from 'o2o_layout';
import { XDMAIcon, XAccIcon, XCDPIcon, XConsoleIcon, NotificationCmp } from 'o2o_layout/lib/common';
import { IState } from '../../../redux/reducer';

import { connect } from 'react-redux';
import { UI } from '../../../redux/model';
import {
  showSiderMainLayout,
  updateLocale,
  typeUpdateLocate,
  updateBreakpoint,
  typeUpdateBreakpoint,
  setGlobalLoading,
  commonActionFromDAL,
  commonActionFromDALV2,
  showCommonError,
} from '../../../common/actions/CommonAction';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';

import './style.scss';

import { canAccess, checkPermission } from '../../../common/helper';

import { Location, History } from 'history';
import queryString from 'query-string';
import { TypeLangs } from '../../../redux/reducer/localeReducer';
import { LinkO2O } from '../../../common/LinkO2O';
import Scrollbars from 'react-custom-scrollbars';
import { UISetting, User } from 'o2o_layout/lib/common/model';

import { userLogout, userLogoutAll } from '../../../modules/login/actions/LoginAction';

import PubSub from 'pubsub-js';
import { extendToken } from '../../../modules/users/ConsoleUsersAction';
import { getUISettingCtx, getUIDataSettingCtx } from '../../../modules/setting/action/UISettingAction';
import { BIGDATA_CONSTANT } from '../../../common/constant';
import { getPrimaryColor } from '../../../common/helper';
import SockJsClient from '../../../shares/SockJsClient';
import { UserDAL } from '../../../dal/UserDAL';
import { Authen } from '../../../redux/model/authen';
import { DrawerQuickAccessComponent } from 'o2o_common_ui';
import { XHappyIcon } from '../../../shares/DMPIcon';
import DrawerCommonError from '../../../shares/CommonError';
import { useDispatch, useSelector } from '../../../redux/store';
import { InternalPermissionDAL } from '../../../modules/users/internal_permission/DAL/InternalPermissionDAL';
import { OWNER_PERMISSION, IActionUI } from '../../../redux/reducer/uiReducer';
import _ from 'lodash';
// import ExpandableSupportButton from '../../../shares/expandable-support-button/ExpandaleSupportButton';
// import { DrawerSupport } from '../../../shares/send-ticket-caresoft/DrawerSupport';
import Sticky from 'react-stickynode';
import AlertLicenseComponent from '@shares/common/alert/AlertLicenseComponent';
import PopoverWithMasking from '../modern/Header/PopoverWithMasking';
import ApplicationDropDownV2 from 'o2o_layout/lib/common/ApplicationDropDownV2';

function mapStateToProps(rootState: IState) {
  return {
    ui: rootState.ui,
    locale: rootState.locale,
    user: rootState.user,
    uiSetting: rootState.uiSetting,
    authen: rootState.authen,
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    showSiderMainLayout: bindActionCreators(showSiderMainLayout, dispatch),
    updateLocale: bindActionCreators(updateLocale, dispatch),
    updateBreakpoint: bindActionCreators(updateBreakpoint, dispatch),
    userLogout: bindActionCreators(userLogout, dispatch),
    userLogoutAll: bindActionCreators(userLogoutAll, dispatch),
    setGlobalLoading: bindActionCreators(setGlobalLoading, dispatch),
    extendToken: bindActionCreators(extendToken, dispatch),
    getUISettingCtx: bindActionCreators(getUISettingCtx, dispatch),
    getUIDataSettingCtx: bindActionCreators(getUIDataSettingCtx, dispatch),
    commonActionFromDAL: bindActionCreators(commonActionFromDAL, dispatch),
    commonActionFromDALV2: bindActionCreators(commonActionFromDALV2, dispatch),
    showCommonError: bindActionCreators(showCommonError, dispatch),
  };
}

export interface DashboardProps extends DashboardPropsType {
  ui?: UI;
  showSiderMainLayout?: any;
  updateLocale: typeUpdateLocate;
  locale: any;
  user?: User;
  selectedLeftNav: any;
  selectedSubMenu?: any;
  location: Location;
  history: History;
  updateBreakpoint: typeUpdateBreakpoint;
  landing?: boolean;
  userLogout: any;
  userLogoutAll: any;
  setGlobalLoading: any;
  extendToken: any;
  getUISettingCtx: any;
  uiSetting: UISetting;
  getUIDataSettingCtx: any;
  commonActionFromDAL: any;
  commonActionFromDALV2: any;
  authen: Authen;
  showCommonError: any;
}

export class DashboardPageComponent extends React.Component<DashboardProps, any> {
  debounceTimeout: any;

  constructor(props: DashboardProps) {
    super(props);
    this.state = {
      isVisible: false,
      // visibleSupport: false,
      breakpoint: this.getScreenSize(),
      heightMenuLeft: window.innerHeight,
      companyName: 'ByteTech',
      isExtending: false,
      isLoadingExtend: false,
      isVisibleBookMark: false,
      menuOffsetBottom: 220,
      heightInterfaceWrapper: 100,
      visibleApplication: false,
    };
    this.handleResize = this.handleResize.bind(this);
    this.handleResize();
  }
  toggleDrawerBookmark = () => {
    this.setState((prevState: any) => {
      return {
        isVisibleBookMark: !prevState.isVisibleBookMark,
      };
    });
  };
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  componentDidUpdate(prevProps: Readonly<DashboardProps>, prevState: Readonly<any>, snapshot?: any): void {
    if (this.props.authen.changePassword !== prevProps.authen.changePassword) {
      if (this.props.authen.changePassword === true) {
        this.props.history.push({
          pathname: '/security/change-password',
        });
      }
    } else if (this.props.authen.restrictEnabled2FA !== prevProps.authen.restrictEnabled2FA) {
      if (this.props.authen.restrictEnabled2FA === true) {
        this.props.history.push({
          pathname: '/security/2fa-security',
        });
      }
    }
  }

  componentDidMount() {
    const userRoles = this.props.user ? (this.props.user.orgCtx ? this.props.user.orgCtx.roles : []) : [];
    this.updateLang();
    window.addEventListener('resize', this.handleResize);
    PubSub.subscribe('EXTEND_TOKEN', this.extendToken);

    if (this.props.authen.changePassword) {
      this.props.history.push({
        pathname: '/security/change-password',
      });
    } else if (this.props.authen.restrictEnabled2FA) {
      this.props.history.push({
        pathname: '/security/2fa-security',
      });
    }

    if (canAccess(['SUPER_ADMIN'], userRoles)) {
      this.loadOwnerHasPermission();
    }
  }

  loadOwnerHasPermission = async () => {
    const dispatch = useDispatch();
    const result = this.props.commonActionFromDALV2(InternalPermissionDAL.hasOwnerPermission);
    try {
      const response = await result;
      dispatch({
        type: OWNER_PERMISSION,
        ownerPermission: response.success,
      } as IActionUI);
    } catch (error) {
      dispatch({
        type: OWNER_PERMISSION,
        ownerPermission: false,
      } as IActionUI);
    }
  };

  openExtendPopup = () => {
    const btn = (
      <Button
        type='primary'
        disabled={this.state.isLoadingExtend}
        size='small'
        onClick={() => {
          this.setState(
            {
              isLoadingExtend: true,
            },
            () => {
              notification.open({
                key: 'extend_noti',
                message: 'Your token has been expending. wait a second',
                description: 'loading...',
              });
              this.props.extendToken().then(() => {
                notification.open({
                  key: 'extend_noti',
                  message: 'Your token has been extended',
                  description: '',
                });
                setTimeout(() => {
                  notification.close('extend_noti');
                }, 1000);

                this.setState({
                  isLoadingExtend: false,
                });
              });
            }
          );
        }}
      >
        Extend
      </Button>
    );

    const args = {
      message: 'Your session is expiring soon',
      description: 'Click the button to extend your session',
      duration: 0,
      key: 'extend_noti',
      btn,
      onClose: () => {
        this.setState({
          isExtending: false,
        });
      },
    };

    notification.open(args);
  };

  extendToken = (a: any, b: any) => {
    if (b) {
      if (!this.state.isExtending) {
        this.setState(
          {
            isLoadingExtend: true,
            isExtending: true,
          },
          () => {
            this.props
              .extendToken()
              .then(() => {
                this.setState({
                  isLoadingExtend: false,
                  isExtending: false,
                });
              })
              .catch(() => {
                this.setState({
                  isLoadingExtend: false,
                  isExtending: false,
                });
              });
          }
        );
        // this.openExtendPopup();
      }
    }
  };

  getScreenSize = () => {
    const { innerWidth } = window;
    let breakpoint = 'xs';

    if (innerWidth >= 1024) {
      breakpoint = 'lg';
    } else if (innerWidth >= 768) {
      breakpoint = 'md';
    } else if (innerWidth >= 400) {
      breakpoint = 'sm';
    }

    return breakpoint;
  };

  handleResize = () => {
    clearTimeout(this.debounceTimeout);

    this.debounceTimeout = setTimeout(() => {
      const breakpoint = this.getScreenSize();
      this.setState({
        breakpoint: breakpoint,
        heightMenuLeft: window.innerHeight,
      });
      this.props.updateBreakpoint(breakpoint, window.innerHeight);

      if (
        this.props.ui &&
        this.props.ui.showSider == true &&
        (breakpoint == 'xs' || breakpoint == 'sm' || breakpoint == 'md')
      ) {
        this.props.showSiderMainLayout(false);
      }
    }, 250);
  };

  getQuery = () => {
    const q = queryString.parse(this.props.location.search);
    return q;
  };

  updateLang = () => {
    let qString = this.props.location.search;
    const parseQuery = queryString.parse(qString);

    if (parseQuery.lang) {
      // debugger
      const lang: TypeLangs = parseQuery.lang == 'vi' || parseQuery.lang == 'en' ? parseQuery.lang : 'vi';

      this.props.updateLocale(lang);
    }
  };

  successChangeLang = (key: string) => {
    let qString = this.props.location.search;
    const parseQuery = queryString.parse(qString);
    parseQuery.lang = key;
    qString = queryString.stringify(parseQuery);
    this.props.history.push({
      pathname: this.props.location.pathname,
      search: qString,
    });
  };

  contentAvatar = () => (
    <AvartarMenuPopover
      avatarSrc={this.props.user ? this.props.user.avatar : ''}
      accountUrl=''
      appUrl=''
      user={this.props.user}
      overrideSignOut={
        <React.Fragment>
          <Col span={24} style={{ marginBottom: 10 }}>
            <Button
              size='small'
              loading={this.props.ui ? this.props.ui.isLoading : false}
              block
              type='link'
              onClick={() => {
                this.props.setGlobalLoading(true);

                this.props.userLogout().then(() => {
                  this.props.setGlobalLoading(false);
                  this.props.history.replace('/login');
                });
              }}
            >
              Logout
            </Button>
          </Col>

          <Divider />
          <Col span={24} style={{ marginBottom: 10 }}>
            <Button
              size='small'
              block
              type='link'
              onClick={() => {
                this.props.setGlobalLoading(true);

                this.props.userLogoutAll().then(() => {
                  this.props.setGlobalLoading(false);
                  this.props.history.replace('/login');
                });
              }}
            >
              Logout all devices
            </Button>
          </Col>
        </React.Fragment>
      }
      urlSelectCompnany={
        <LinkO2O {...this.props} to={{ pathname: '/companies/select' }}>
          {this.props.user ? (this.props.user.orgCtx ? this.props.user.orgCtx.organization.name : '') : ''}{' '}
          <Icon type='right' />
        </LinkO2O>
      }
      urlSelectProfile={
        <div style={{ marginTop: 10, fontSize: 15 }}>
          <LinkO2O {...this.props} to={{ pathname: '/my-account-info' }}>
            My Profile
          </LinkO2O>
        </div>
      }
    />
  );

  calculateTextSelectTrackingId = (text: string) => {
    if (this.props.ui) {
      if (this.props.ui.breakpoint == 'xs' || this.props.ui.breakpoint == 'sm') {
        return 'Select Tracking';
      } else if (this.props.ui.breakpoint == 'lg') {
        return text;
      }
    } else {
      return text;
    }
    return text;
  };

  contentApplication = () => {
    return (
      <Row
        className='popover-o2o-avatar'
        style={{ textAlign: 'center', padding: '10px' }}
        gutter={[16, 16]}
        align='middle'
        justify='start'
        type='flex'
      >
        <Col style={{ marginBottom: 10 }}>
          <Card bordered={true} hoverable style={{ height: 110, width: 80 }} size='small'>
            <a href={process.env.REACT_APP_ACCOUNT_APP} target='_blank'>
              <Icon
                component={() => {
                  return (
                    <XAccIcon
                      fillBackground={
                        this.props.uiSetting.themeColor
                          ? this.props.uiSetting.themeColor
                          : BIGDATA_CONSTANT.primaryColor
                      }
                    />
                  );
                }}
                style={{ fontSize: 40, marginBottom: 10 }}
              />
              <p>
                <Typography.Text strong style={{ fontSize: 10, color: '#000' }}>
                  ACC
                </Typography.Text>
              </p>
            </a>
          </Card>
        </Col>

        <Col style={{ marginBottom: 10 }}>
          <Card bordered={false} hoverable style={{ height: 110, width: 80 }} size='small'>
            <a href={process.env.REACT_APP_CDP_APP} target='_blank'>
              <Icon
                component={() => {
                  return (
                    <XCDPIcon
                      fillBackground={
                        this.props.uiSetting.themeColor
                          ? this.props.uiSetting.themeColor
                          : BIGDATA_CONSTANT.primaryColor
                      }
                    />
                  );
                }}
                style={{ fontSize: 40, marginBottom: 10 }}
              />
              <p>
                <Typography.Text strong style={{ fontSize: 10, color: '#000' }}>
                  CDP
                </Typography.Text>
              </p>
            </a>
          </Card>
        </Col>

        <Col style={{ marginBottom: 10 }}>
          <Card bordered={false} hoverable style={{ height: 110, width: 80 }} size='small'>
            <a href={process.env.REACT_APP_CON_APP} target='_blank'>
              <Icon
                component={() => {
                  return (
                    <XConsoleIcon
                      fillBackground={
                        this.props.uiSetting.themeColor
                          ? this.props.uiSetting.themeColor
                          : BIGDATA_CONSTANT.primaryColor
                      }
                    />
                  );
                }}
                style={{ fontSize: 40, marginBottom: 10 }}
              />
              <p>
                <Typography.Text strong style={{ fontSize: 10, color: '#000' }}>
                  CON
                </Typography.Text>
              </p>
            </a>
          </Card>
        </Col>

        <Col style={{ marginBottom: 10 }}>
          <Card bordered={false} hoverable style={{ height: 110, width: 80 }} size='small'>
            <a href={process.env.REACT_APP_DMA_APP} target='_blank'>
              <Icon
                component={() => {
                  return (
                    <XDMAIcon
                      fillBackground={
                        this.props.uiSetting.themeColor
                          ? this.props.uiSetting.themeColor
                          : BIGDATA_CONSTANT.primaryColor
                      }
                    />
                  );
                }}
                style={{ fontSize: 40, marginBottom: 10 }}
              />
              <p>
                <Typography.Text strong style={{ fontSize: 10, color: '#000' }}>
                  DMA
                </Typography.Text>
              </p>
            </a>
          </Card>
        </Col>

        <Col style={{ marginBottom: 10 }}>
          <Card bordered={false} hoverable style={{ height: 110, width: 80 }} size='small'>
            <a href={process.env.REACT_APP_ACT_APP} target='_blank'>
              <Icon
                component={() => {
                  return (
                    <XHappyIcon
                      fillBackground={
                        this.props.uiSetting.themeColor
                          ? this.props.uiSetting.themeColor
                          : BIGDATA_CONSTANT.primaryColor
                      }
                    />
                  );
                }}
                style={{ fontSize: 40, marginBottom: 10 }}
              />
              <p>
                <Typography.Text strong style={{ fontSize: 10, color: '#000' }}>
                  ACT
                </Typography.Text>
              </p>
            </a>
          </Card>
        </Col>
      </Row>
    );
  };

  renderRightZone = () => {
    return (
      <Row type='flex' justify='end'>
        {/* <Col>
                    <Button onClick={() => {
                        this.setState({
                            visibleSupport: true
                        })
                    }}>
                        <Avatar icon="question" style={{ background: "transparent", border: "1px solid #fff" }} ></Avatar>
                    </Button>
                </Col> */}

        <Col>
          <Button onClick={this.toggleDrawerBookmark}>
            <Avatar
              src='https://res.cloudinary.com/bytetech-jsc/image/upload/v1660833977/pangoCDP/default/pango_quick_path_f36rci.svg'
              style={{ background: 'transparent' }}
            ></Avatar>
          </Button>
        </Col>

        <Col>
          <NotificationCmp
            viewAllText='View all'
            urlAccount={`${process.env.REACT_APP_CON_APP}system/notifications`}
            userDAL={UserDAL}
            notifications={this.state.noti}
            commontActionFromDAL={this.props.commonActionFromDAL}
          />
        </Col>

        {/* <Col>
          <Popover
            className='o2o-popover'
            placement='bottom'
            content={this.contentApplication()}
            title=''
            trigger='click'
          >
            <Button>
              <Avatar icon='appstore' style={{ background: '#956DD1' }}></Avatar>
            </Button>
          </Popover>
        </Col> */}

        <Col>
          <PopoverWithMasking
            className='o2o-popover'
            placement='bottomLeft'
            content={
              <ApplicationDropDownV2
                activeApp='account'
                uiSetting={this?.props?.uiSetting}
                user={this?.props?.user}
                applicationHrefs={{
                  'data-hub': process.env.REACT_APP_CDP_APP!,
                  automation: process.env.REACT_APP_DMA_APP!,
                  console: process.env.REACT_APP_CON_APP!,
                  account: process.env.REACT_APP_ACCOUNT_APP!,
                  activation: process.env.REACT_APP_ACT_CON_APP!,
                  'help-center': 'https://help.pangocdp.com/',
                  pconnext: process.env.REACT_APP_PCX_CONSOLE!,
                  'pconnext-vus': process.env.REACT_APP_PCX_VUS_CONSOLE!,
                  'social-crm': process.env.REACT_APP_SOCIAL_CRM_APP!,
                }}
              />
            }
            title=''
            trigger='click'
            visible={this.state.visibleApplication}
            onVisibleChange={(visible) => {
              this.setState({
                visibleApplication: visible,
              });
            }}
          >
            <Button>
              <Avatar icon='appstore' style={{ background: '#956DD1' }}></Avatar>
            </Button>
          </PopoverWithMasking>
        </Col>

        <Col>
          <Popover
            className='o2o-popover'
            overlayClassName='o2o-popover-inner'
            placement='bottomRight'
            content={this.contentAvatar()}
            title=''
            trigger='click'
          >
            <Button>
              <Avatar
                src={this.props.user && this.props.user.avatar ? this.props.user.avatar : ''}
                icon='user'
                style={{ background: '#956DD1', border: '1px solid #fff' }}
              ></Avatar>
            </Button>
          </Popover>
        </Col>
      </Row>
    );
  };

  renderLeftZone = (userRoles: any, lang: any) => {
    // const hasOwnerPermission = useSelector((state: IState) => state.ui.ownerPermission);
    return (
      <Menu
        theme='light'
        defaultSelectedKeys={[this.props.selectedLeftNav]}
        defaultOpenKeys={[this.props.selectedSubMenu]}
        style={{ borderColor: 'transparent', marginBottom: 20 }}
        mode='inline'
      >
        <Menu.Item key='my-info'>
          <Link
            to={{
              pathname: '/my-account-info',
              search: queryString.stringify({ lang: lang }),
            }}
          >
            <Icon type='user' /> Profile
          </Link>
        </Menu.Item>
        <Menu.Item key='my-security'>
          <Link
            to={{
              pathname: '/security/2fa-security',
              search: queryString.stringify({ lang: lang }),
            }}
          >
            <Icon type='security-scan' /> Security
          </Link>
        </Menu.Item>

        <Menu.SubMenu
          key='activity'
          title={
            <span>
              <Icon type='solution' />
              <span>Activity</span>
            </span>
          }
        >
          <Menu.Item key='invitation'>
            <LinkO2O to={{ pathname: '/activity/invitation' }} {...this.props}>
              <Icon type='usergroup-add' />
              <span>Invitation</span>
            </LinkO2O>
          </Menu.Item>

          <Menu.Item key='exports-history'>
            <LinkO2O to={{ pathname: '/activity/exports-history' }} {...this.props}>
              <Icon type='export' />
              <span>Exports History</span>
            </LinkO2O>
          </Menu.Item>

          <Menu.Item key='login-history'>
            <LinkO2O to={{ pathname: '/activity/login-history' }} {...this.props}>
              <Icon type='solution' />
              <span>Login Activity</span>
            </LinkO2O>
          </Menu.Item>
        </Menu.SubMenu>

        {canAccess(['ADMIN', 'SUPER_ADMIN'], userRoles) ? (
          <Menu.SubMenu
            key='console'
            title={
              <span>
                <Icon type='setting' />
                <span>Admin</span>
              </span>
            }
          >
            {canAccess(['ADMIN', 'SUPER_ADMIN'], userRoles) ? (
              <Menu.Item key='organization'>
                <LinkO2O to={{ pathname: '/organization' }} {...this.props}>
                  <Icon type='apartment' />
                  <span>Organization</span>
                </LinkO2O>
              </Menu.Item>
            ) : null}

            <Menu.Item key='13'>
              <Link
                to={{
                  pathname: '/console-users',
                  search: queryString.stringify({ lang: lang }),
                }}
              >
                <Icon type='user' /> Accounts
              </Link>
            </Menu.Item>
            {checkPermission('AccountPermission', this.props.authen.permission) && (
              <Menu.Item key='13'>
                <Link
                  to={{
                    pathname: '/console-users',
                    search: queryString.stringify({ lang: lang }),
                  }}
                >
                  <Icon type='user' /> Users
                </Link>
              </Menu.Item>
            )}

            {canAccess(['SUPER_ADMIN', 'ADMIN'], userRoles) ? (
              <Menu.Item key='group-permision'>
                <LinkO2O to={{ pathname: '/permission-group' }} {...this.props}>
                  <Icon type='apartment' />
                  <span>Permission Group</span>
                </LinkO2O>
              </Menu.Item>
            ) : null}

            {canAccess(['SUPER_ADMIN', 'ADMIN'], userRoles) ? (
              <Menu.Item key='activity'>
                <LinkO2O to={{ pathname: '/console-activity' }} {...this.props}>
                  <Icon type='solution' />
                  <span>Activities</span>
                </LinkO2O>
              </Menu.Item>
            ) : null}
          </Menu.SubMenu>
        ) : null}
        {canAccess(['SUPER_ADMIN'], userRoles) ? (
          <Menu.SubMenu
            key='console-super'
            title={
              <span>
                <Icon type='safety' />
                <span>Super Admin</span>
              </span>
            }
          >
            {canAccess(['SUPER_ADMIN'], userRoles) ? (
              <Menu.Item key='12'>
                <Link
                  to={{
                    pathname: '/console-organizations',
                    search: queryString.stringify({ lang: lang }),
                  }}
                >
                  <Icon type='apartment' /> Organization
                </Link>
              </Menu.Item>
            ) : null}
            {canAccess(['SUPER_ADMIN'], userRoles) ? (
              <Menu.Item key='super-admin-console-users'>
                <Link
                  to={{
                    pathname: '/super-admin-console-users',
                    search: queryString.stringify({ lang: lang }),
                  }}
                >
                  <Icon type='user' /> Accounts
                </Link>
              </Menu.Item>
            ) : null}
            {canAccess(['SUPER_ADMIN'], userRoles) ? (
              <Menu.Item key='permission'>
                <LinkO2O to={{ pathname: '/console-permission' }} {...this.props}>
                  <Icon type='apartment' />
                  <span>Permission</span>
                </LinkO2O>
              </Menu.Item>
            ) : null}
            {/* {canAccess(['SUPER_ADMIN'], userRoles) && hasOwnerPermission ? (
              <Menu.Item key='internal_permission'>
                <LinkO2O to={{ pathname: '/internal-permission' }} {...this.props}>
                  <Icon type='apartment' />
                  <span>Internal Permission</span>
                </LinkO2O>
              </Menu.Item>
            ) : null} */}
            {canAccess(['SUPER_ADMIN'], userRoles) ? (
              <Menu.Item key='menu_link_org'>
                <Link
                  to={{
                    pathname: '/console-link-orgs',
                    search: queryString.stringify({ lang: lang }),
                  }}
                >
                  <Icon type='link' /> Link Company
                </Link>
              </Menu.Item>
            ) : null}
            {canAccess(['SUPER_ADMIN'], userRoles) ? (
              <Menu.Item key='menu_import'>
                <Link
                  to={{
                    pathname: '/console-system-setting',
                    search: queryString.stringify({ lang: lang }),
                  }}
                >
                  <Icon type='setting' /> System Setting
                </Link>
              </Menu.Item>
            ) : null}
          </Menu.SubMenu>
        ) : null}
      </Menu>
    );
  };

  getCommonError = () => {
    const commonError = useSelector((state: IState) => state.ui.commonError);
    return commonError;
  };

  render() {
    const userRoles = this.props.user ? (this.props.user.orgCtx ? this.props.user.orgCtx.roles : []) : [];

    const qString = this.props.location.search;
    const parseQuery = queryString.parse(qString);
    let lang = parseQuery.lang;
    const { landing } = this.props;
    return (
      <LocaleProvider locale={this.props.locale ? (this.props.locale.locale == 'en' ? enEn : viVn) : viVn}>
        <React.Fragment>
          <DashboardLayout
            showSider={this.props.ui ? this.props.ui.showSider : false}
            logoNode={
              this.props.user && _.get(this.props.user, 'orgCtx.organization.imageLink', undefined) ? (
                <Avatar
                  style={{ marginBottom: 10 }}
                  shape={'circle'}
                  size={80}
                  src={_.get(this.props.user, 'orgCtx.organization.imageLink', undefined)}
                />
              ) : (
                <Icon
                  component={() => {
                    return <XAccIcon fillBackground={getPrimaryColor(this.props.uiSetting)} />;
                  }}
                  style={{ fontSize: 80, marginBottom: 10 }}
                />
              )
            }
            showSiderMainLayout={this.props.showSiderMainLayout}
            logo={this.props.ui ? this.props.ui.logo : null}
            logoSecond={this.props.ui ? this.props.ui.logoSecond : null}
            companyName2={
              this.props.user
                ? this.props.user.orgCtx
                  ? this.props.user.orgCtx.organization.name
                  : this.state.companyName
                : this.state.companyName
            }
            companyName={
              this.props.user && _.get(this.props.user, 'orgCtx.organization.imageLink', undefined) ? (
                ((
                  <>
                    <div
                      style={{
                        color: 'var(--primary-color)',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        padding: '0px 10px 0px 10px',
                      }}
                    >
                      <span style={{ fontWeight: 400 }}>
                        {this.props.user
                          ? this.props.user.orgCtx
                            ? this.props.user.orgCtx.organization.name
                            : this.state.companyName
                          : this.state.companyName}
                      </span>
                    </div>
                    <div style={{ color: '#242425' }}>Account Management (ACC)</div>
                  </>
                ) as any)
              ) : (
                <div
                  style={{
                    color: 'var(--primary-color)',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    padding: '0px 10px 0px 10px',
                  }}
                >
                  <span style={{ fontWeight: 400 }}>
                    {this.props.user
                      ? this.props.user.orgCtx
                        ? this.props.user.orgCtx.organization.name
                        : this.state.companyName
                      : this.state.companyName}
                  </span>
                </div>
              )
            }
            navTopRight={!landing ? this.renderRightZone() : null}
            leftMenu={
              !landing ? (
                <div>
                  <Scrollbars
                    autoHide
                    style={{
                      height: this.state.heightMenuLeft - this.state.menuOffsetBottom,
                      marginTop: -20,
                      overflowX: 'hidden',
                    }}
                  >
                    {this.renderLeftZone(userRoles, lang)}
                  </Scrollbars>
                  <div>
                    <Sticky bottomBoundary={0}>
                      <div
                        style={{
                          height: 100,
                          borderTop: '1px solid #e8e8e8',
                        }}
                        onClick={() => {
                          if (this.state.heightInterfaceWrapper === 200) {
                            this.setState({
                              heightInterfaceWrapper: 100,
                              menuOffsetBottom: 220,
                            });
                          } else {
                            this.setState({
                              heightInterfaceWrapper: 200,
                              menuOffsetBottom: 220 + 100,
                            });
                          }
                        }}
                      >
                        <div
                          style={{
                            padding: '10px 18px 10px 25px',
                            cursor: 'pointer',
                          }}
                        >
                          <Row type='flex' justify='space-between'>
                            <Col
                              style={{
                                fontWeight: 'bold',
                                color: '#AAA',
                              }}
                            >
                              INTERFACE
                            </Col>
                            <Col>
                              {this.state.heightInterfaceWrapper === 200 ? (
                                <Icon
                                  component={() => {
                                    return (
                                      <svg
                                        width='8'
                                        height='5'
                                        viewBox='0 0 8 5'
                                        fill='none'
                                        xmlns='http://www.w3.org/2000/svg'
                                      >
                                        <path
                                          d='M6.34679 3.89821L4.02565 1.48251L1.69966 3.89832L1.69968 3.89833L1.69767 3.90034C1.6202 3.97781 1.51524 4.01816 1.40689 4.01816C1.17463 4.01816 0.993005 3.83853 0.993005 3.60692C0.993005 3.48672 1.04537 3.38914 1.11067 3.31658L1.11062 3.31653L1.11397 3.31304L3.71585 0.602957L3.71574 0.602858L3.72049 0.598324C3.79737 0.524959 3.89858 0.467129 4.02461 0.467129C4.14682 0.467129 4.25647 0.521827 4.33461 0.606926L6.9343 3.3147C7.00956 3.39053 7.05619 3.49073 7.05619 3.60692C7.05619 3.83852 6.87458 4.01816 6.64232 4.01816C6.53659 4.01816 6.43072 3.97792 6.35181 3.90319L6.3517 3.90331L6.34679 3.89821Z'
                                          fill='currentColor'
                                          stroke='currentColor'
                                          stroke-width='0.3'
                                          stroke-linejoin='round'
                                        />
                                      </svg>
                                    );
                                  }}
                                />
                              ) : (
                                <Icon
                                  component={() => {
                                    return (
                                      <svg
                                        width='15'
                                        height='14'
                                        viewBox='0 0 15 14'
                                        fill='none'
                                        xmlns='http://www.w3.org/2000/svg'
                                      >
                                        <path
                                          fill-rule='evenodd'
                                          clip-rule='evenodd'
                                          d='M3.5533 4.83785C3.32549 5.06565 3.32549 5.435 3.5533 5.6628L7.0533 9.1628C7.28111 9.39061 7.65045 9.39061 7.87826 9.1628L11.3783 5.6628C11.6061 5.435 11.6061 5.06565 11.3783 4.83785C11.1505 4.61004 10.7811 4.61004 10.5533 4.83785L7.46578 7.92537L4.37826 4.83785C4.15045 4.61004 3.78111 4.61004 3.5533 4.83785Z'
                                          fill='currentColor'
                                        />
                                      </svg>
                                    );
                                  }}
                                />
                              )}
                            </Col>
                          </Row>

                          {this.state.heightInterfaceWrapper === 100 ? null : (
                            <Row gutter={[10, 20]} className='mt20' align='middle'>
                              <Col
                                xs={24}
                                style={{
                                  color: 'var(--primary-color)',
                                }}
                              >
                                <Icon
                                  component={() => {
                                    return (
                                      <svg
                                        width='18'
                                        height='19'
                                        viewBox='0 0 18 14'
                                        fill='none'
                                        xmlns='http://www.w3.org/2000/svg'
                                      >
                                        <path
                                          d='M4.73422 12.398H5.73994V13.2512C5.73994 14.4547 6.37275 15.0818 7.59317 15.0818H13.2659C14.4863 15.0818 15.1191 14.4547 15.1191 13.2512V7.53892C15.1191 6.3298 14.4863 5.70264 13.2659 5.70264H12.3054V4.80427C12.3054 3.6008 11.6726 2.97363 10.4521 2.97363H4.73422C3.51379 2.97363 2.88098 3.59515 2.88098 4.80427V10.5617C2.88098 11.7709 3.51379 12.398 4.73422 12.398ZM4.80202 11.2906C4.27656 11.2906 3.9884 11.0194 3.9884 10.4713V4.90032C3.9884 4.35226 4.27656 4.0754 4.80202 4.0754H10.39C10.9098 4.0754 11.2036 4.35226 11.2036 4.90032V5.70264H7.59317C6.37275 5.70264 5.73994 6.3298 5.73994 7.53892V11.2906H4.80202Z'
                                          fill='currentColor'
                                        />
                                      </svg>
                                    );
                                  }}
                                />{' '}
                                <span>Standard interface</span>
                              </Col>
                              <Col
                                xs={24}
                                style={{
                                  cursor: 'pointer',
                                }}
                                onClick={() => {
                                  PubSub.publish('CHANGE_LAYOUT', 'v2');
                                  message.info({
                                    content: 'Switched to the modern interface',
                                  });
                                }}
                              >
                                <Icon
                                  component={() => {
                                    return (
                                      <svg
                                        width='18'
                                        height='19'
                                        viewBox='0 0 18 14'
                                        fill='none'
                                        xmlns='http://www.w3.org/2000/svg'
                                      >
                                        <path
                                          d='M4.73422 12.398H5.73994V13.2512C5.73994 14.4547 6.37275 15.0818 7.59317 15.0818H13.2659C14.4863 15.0818 15.1191 14.4547 15.1191 13.2512V7.53892C15.1191 6.3298 14.4863 5.70264 13.2659 5.70264H12.3054V4.80427C12.3054 3.6008 11.6726 2.97363 10.4521 2.97363H4.73422C3.51379 2.97363 2.88098 3.59515 2.88098 4.80427V10.5617C2.88098 11.7709 3.51379 12.398 4.73422 12.398ZM4.80202 11.2906C4.27656 11.2906 3.9884 11.0194 3.9884 10.4713V4.90032C3.9884 4.35226 4.27656 4.0754 4.80202 4.0754H10.39C10.9098 4.0754 11.2036 4.35226 11.2036 4.90032V5.70264H7.59317C6.37275 5.70264 5.73994 6.3298 5.73994 7.53892V11.2906H4.80202ZM10.7233 12.7709C10.599 12.7709 10.5143 12.6862 10.4917 12.5675C10.2318 10.8442 10.0058 10.4996 8.23164 10.2962C8.10733 10.2792 8.02258 10.1888 8.02258 10.0702C8.02258 9.95717 8.10733 9.86677 8.23164 9.84417C10.0114 9.60686 10.1866 9.30741 10.4917 7.57282C10.5199 7.45417 10.6047 7.37507 10.7233 7.37507C10.8363 7.37507 10.9267 7.45982 10.9437 7.57847C11.2092 9.28481 11.4409 9.60686 13.2094 9.84417C13.3337 9.86677 13.4184 9.95717 13.4184 10.0702C13.4184 10.1888 13.3337 10.2849 13.2094 10.2962C11.424 10.5335 11.2544 10.8499 10.9437 12.5732C10.9211 12.6862 10.8363 12.7709 10.7233 12.7709ZM8.37289 13.7314C8.28249 13.7314 8.22599 13.6693 8.19774 13.5789C8.03953 12.7314 8.10168 12.6975 7.18637 12.5562C7.08466 12.5393 7.02816 12.4828 7.02816 12.3924C7.02816 12.3076 7.08466 12.2398 7.16942 12.2229C8.10168 12.0647 8.03953 12.0364 8.19774 11.2002C8.22599 11.1041 8.28814 11.042 8.37289 11.042C8.46329 11.042 8.51979 11.1098 8.54239 11.2002C8.69495 12.0421 8.64975 12.076 9.57636 12.2229C9.66112 12.2398 9.72327 12.3076 9.72327 12.3924C9.72327 12.4715 9.66112 12.5393 9.57636 12.5562C8.64975 12.7031 8.69495 12.737 8.54239 13.5902C8.51979 13.6749 8.45764 13.7314 8.37289 13.7314Z'
                                          fill='#1C1C1E'
                                        />
                                      </svg>
                                    );
                                  }}
                                />{' '}
                                <span>Modern interface</span>
                              </Col>
                            </Row>
                          )}
                        </div>
                      </div>
                    </Sticky>
                  </div>
                </div>
              ) : (
                <Scrollbars autoHide style={{ height: this.state.heightMenuLeft - 185 }}>
                  <Menu
                    theme='light'
                    defaultSelectedKeys={[this.props.selectedLeftNav]}
                    defaultOpenKeys={[this.props.selectedSubMenu]}
                    style={{ borderColor: 'transparent', marginBottom: 20 }}
                    mode='inline'
                  >
                    <Menu.Item key='9'>
                      <Link to='/help'>
                        <Icon type='question' />
                        <span>Help</span>
                      </Link>
                    </Menu.Item>

                    <Menu.Item key='10'>
                      <Link to='/policy'>
                        <span>Privacy Policy</span>
                      </Link>
                    </Menu.Item>
                  </Menu>
                </Scrollbars>
              )
            }
          >
            <AlertLicenseComponent className='mb20' />
            <div>{this.props.children}</div>

            {/* <DrawerSupport
              commonActionFromDALV2={this.props.commonActionFromDALV2}
              visible={this.state.visibleSupport}
              onClose={() => {
                this.setState({
                  visibleSupport: false,
                });
              }}
            /> */}

            <DrawerQuickAccessComponent
              title='QUICK ACCESS'
              visible={this.state.isVisibleBookMark}
              onClose={this.toggleDrawerBookmark}
              commonActionFromDALV2={this.props.commonActionFromDALV2}
              application='ACCOUNT'
              api_prefix={BIGDATA_CONSTANT.url.account || ''}
              baseUrlCDP={process.env.REACT_APP_CDP_APP || ''}
              baseUrlCON={process.env.REACT_APP_CON_APP || ''}
              baseUrlDMA={process.env.REACT_APP_DMA_APP || ''}
              color={getPrimaryColor(this.props.uiSetting)}
            />

            <DrawerCommonError
              visible={this.getCommonError() ? true : false}
              onClose={() => {
                this.props.showCommonError(undefined);
              }}
            />

            {this.props.user ? (
              <SockJsClient
                url={process.env.REACT_APP_SOCKET_URL}
                topics={[
                  // '/topic/global/messages',
                  `/topic/orgs/${this.props.user.orgCtx ? this.props.user.orgCtx.orgId : ''}/messages`,
                  `/topic/users/${this.props.user.orgCtx ? this.props.user.orgCtx.orgId : ''}_${this.props.user.id
                  }/messages`,
                  `/topic/users/${this.props.user.orgCtx ? this.props.user.orgCtx.orgId : ''}_${this.props.user.id
                  }/messages/stats`,
                ]}
                onMessage={(msg: any, header: any) => {
                  if (
                    this.props.user &&
                    header ==
                    `/topic/users/${this.props.user.orgCtx ? this.props.user.orgCtx.orgId : ''}_${this.props.user.id
                    }/messages/stats`
                  ) {
                    this.setState({
                      noti: msg,
                    });
                  } else {
                    if (msg) {
                      notification[msg.messageLevel || 'info']({
                        message: msg.title || 'Title',
                        description: msg.message,
                        duration: 0,
                      });
                    }
                  }
                }}
              />
            ) : null}

            {/* <ExpandableSupportButton
              openFormCaresoft={() => {
                this.setState({
                  visibleSupport: true,
                });
              }}
            /> */}
          </DashboardLayout>

          <FooterO2OComponent style={{ float: 'right', textAlign: 'right' }}></FooterO2OComponent>
        </React.Fragment>
      </LocaleProvider>
    );
  }
}

const StandardLayoutContainer = connect<any, any>(mapStateToProps, mapDispatchToProps)(DashboardPageComponent);

export default StandardLayoutContainer;
